export default __webpack_public_path__ + "static/media/PowerDrillImg.e7751525.png";